import { getDefaultClient } from '../../../client/defaultClient';
import { getWalletProviderByKey } from '../getWalletProviderByKey';
import type { WalletProviderData } from '../walletProvider';

type GetWalletProviderDataByKeyParams = {
  walletProviderKey: string;
};

/**
 * Retrieves data for a specific wallet provider that can be used for display or connection.
 *
 * @param params.walletProviderKey - The key of the wallet provider to retrieve data for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns The data for the wallet provider.
 */
export const getWalletProviderDataByKey = (
  { walletProviderKey }: GetWalletProviderDataByKeyParams,
  client = getDefaultClient()
): WalletProviderData => {
  const { chain, groupKey, key, metadata, walletProviderType } =
    getWalletProviderByKey({ walletProviderKey }, client);

  return { chain, groupKey, key, metadata, walletProviderType };
};
